module.exports = __webpack_public_path__ + "_/favicon.15104b703439bc1e74cbbfe95dfa8817.png";